import React from "react";
class PositionList extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {renderItem,dataSource,topDistance,bottomDistance,header,background}=this.props;
    console.log('====dataSource===',dataSource)
    return (
      <div style={{marginBottom:'.2rem'}}>
        {header}
        <div style={{paddingTop:topDistance,paddingBottom:bottomDistance,background}}>
          {dataSource.map((v,i)=>{
           return  renderItem(v)})}
        </div>
      </div>
    );
  }
}


export default PositionList



// WEBPACK FOOTER //
// ./src/components/PositionList.js